<template>
    <div class="apprentice-simple-card files-management">
        <div
            class="watch-groups"
            v-if="inviteCheckUrl">
            <b-button
                class="btn-disable-group-options"
                v-if="!!group.group_pair_options && !group.group_pair_options.deleted_at"
                variant="danger"
                @click="disableGroupPairOptions">
                <i class="btn-remove"></i>{{ $t('group.settings.expand_group_making_tool') }}
            </b-button>
            <b-button
                class="btn-show-group"
                variant="primary"
                :href="inviteCheckUrl"
                ><i class="btn-open"></i>{{ $t('group.settings.view_groups') }}
            </b-button>
        </div>

        <design-2021-group-grouppair-options-component
            v-if="!group.group_pair_options || !group.group_pair_options.deleted_at"
            :group-in="group"
            :courses-in="coursesIn"
            :invite-check-url="inviteCheckUrl"
            ref="group-grouppair-options-component"></design-2021-group-grouppair-options-component>
        <div v-else>
            <div class="apprentice-simple-card files-management">
                <div class="not-found with-header empty-admin-users-list">
                    <div
                        class="btn-add-circle icon"
                        @click="reEnableGroupPairOptions"></div>

                    <div class="alert-notice">
                        {{ $t('group.settings.click_here_to_turn_the_group_making_tool_on_again') }}
                    </div>
                </div>
            </div>
        </div>
        <div
            class="btn-save-group-settings"
            v-if="!group.group_pair_options || !group.group_pair_options.deleted_at">
            <b-button
                class="btn-save"
                variant="primary"
                @click="update">
                {{ $t('common.save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-management-component',
    props: ['groupIn', 'coursesIn'],
    data() {
        return {
            group: this.groupIn,
            inviteCheckUrl: this.routes.groupInvitesCheck(this.groupIn.id),
        };
    },
    methods: {
        update() {
            const data = this.$refs['group-grouppair-options-component'].getData();

            if (data.errors) {
                this.alert.warning(
                    this.$t('group.settings.incomplete_form'),
                    this.$t('group.settings.not_all_choices_have_been_made_please_select_all_required_options'),
                );

                return;
            }

            this.alert.saving();
            if (!this.groupIn.group_pair_options) {
                this.axios.post(this.routes.groupPairOptionsStore(), data).then(
                    (response) => {
                        this.group.group_pair_options = response.data;
                        this.$emit('add-group', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.axios.post(this.routes.groupPairOptionsUpdate(this.groupIn.group_pair_options.id), data).then(
                    (response) => {
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
        disableGroupPairOptions() {
            this.alert
                .confirm(
                    this.$t('group.settings.turn_off'),
                    this.$t('group.settings.are_you_sure_you_want_to_turn_off_the_group_making_tool'),
                    this.$t('group.settings.turn_off'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.groupPairOptionsUpdate(this.groupIn.group_pair_options.id)).then(
                            (response) => {
                                this.group.group_pair_options.deleted_at = response.data;
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        reEnableGroupPairOptions() {
            this.alert
                .confirm(
                    this.$t('group.settings.turn_off'),
                    this.$t('group.settings.are_you_sure_you_want_to_turn_on_the_group_making_tool'),
                    this.$t('group.settings.turn_on'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.post(this.routes.groupPairOptionsRestore(this.groupIn.group_pair_options.id)).then(
                            (response) => {
                                this.group.group_pair_options.deleted_at = null;
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.watch-groups {
    flex: initial;
    flex-direction: row;
    justify-content: flex-end;
    display: flex;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
}

.btn-show-group,
.btn-disable-group-options {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    i {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.btn-save-group-settings {
    display: flex;
    align-items: center;
    justify-content: right;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
